<div class="confirmation-container">
  <div>
    <frodo-title [text]="title"></frodo-title>
  </div>
  <div><frodo-icon [src]="image" [alt]="imageAlt"></frodo-icon></div>
  <div><frodo-logo [src]="logo" [alt]="logoAlt"></frodo-logo></div>
</div>
